import type { IconData } from '@stacksjs/iconify-core'

export const paintbrush2: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"m44.567 13.03l-8.586 13.637c-.638 1.012-1.56 1.814-2.676 2.245C31.172 29.735 27.491 31 25 31c0 0 .22-2.78-2.5-5.5S17 23 17 23c0-2.54 1.367-6.246 2.231-8.335c.433-1.046 1.198-1.911 2.152-2.52L35 3.447c.31-.199.637-.37.994-.461c1.208-.307 4.278-.713 7.012 2.02c2.75 2.75 2.315 5.862 2.005 7.062a3.5 3.5 0 0 1-.444.962\"/><path d=\"M17 23C4.832 23 4.398 30.684 4.07 36.487c-.093 1.633-.177 3.116-.511 4.238q-.068.224-.144.449c-.223.68-.45 1.371-.25 2.046C3.52 44.42 4.467 45 6.143 45C17.524 45 24.939 43.016 25 30.654m9.962-2.77c-.165-1.893-1.007-5.918-4.968-9.879c-3.849-3.849-7.758-4.753-9.713-4.952\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default paintbrush2
